import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BanUserModel } from "src/app/models/common/ban-user-model";
import { BackendListModel } from "src/app/models/common/list.model";
import { RejectionReasonModel } from "src/app/models/common/myteam-model";
import { USER_ROLE_TYPE_EXTERNAL } from "src/app/models/common/user-role";
import { ProfileRole } from "src/app/models/profile-role";
import { ApiRoutes } from "src/app/services/apiroutes";

@Injectable({
    providedIn: 'root'
})

export class MyTeamService {
    base_url = ApiRoutes.Company;

    constructor(private http: HttpClient) { }

    postInviteEmails(data) {
        let url = `${this.base_url}external_bulk_invite/`;
        return this.http.post(url, data);
    }

    approveTeamMember(data) {
        let url = `${this.base_url}external_admin_approval/`;
        return this.http.post(url, data);
    }

    rejectTeamMember(data) {
        let url = `${this.base_url}external_admin_reject/`;
        return this.http.post(url, data);
    }

    getRole(): Observable<BackendListModel<ProfileRole>> {
        let url = `${this.base_url}profile_role/?type=${USER_ROLE_TYPE_EXTERNAL}`;
        return this.http.get<BackendListModel<ProfileRole>>(url);
    }

    banUser(data: BanUserModel) {
        let url = `${this.base_url}ban-user/`;
        return this.http.post<BanUserModel>(url, data);
    }

    uninviteUser(id: string) {
        let url = `${this.base_url}external_invite/${id}/`;
        return this.http.delete(url, { observe: 'response' });
    }

    getRejectionReason() {
        let url = `${this.base_url}external_rejection_reason/`;
        return this.http.get<BackendListModel<RejectionReasonModel>>(url);
    }
}